import UserActions from '../../actions/UserActions';
import AuthActions from '../../actions/AuthActions';
import UserApi from '../../api/UserApi';

class GLLocation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedId: '',
            flags: null,
        };

        this.selectLocation = this.selectLocation.bind(this);
        this.handleSelectLocationButtonClick = this.handleSelectLocationButtonClick.bind(this);
    }

    async componentDidMount() {
        // hide header if flag is enabled
        let flags = {};

        try {
            const response = await UserApi.getLaunchDarklyFlags({
                LspId: this.props.user.LspId,
                LocId: null,
            });
            flags = response.Data;
        } catch (error) {
            console.error('Error fetching flags', error);
        } finally {
            this.setState({ flags });
        }
    }

    selectLocation(loc) {
        if (loc.location_id === this.props.selectedLocation.location_id) return;

        UserActions.selectLocation(loc);
    }

    handleSelectLocationButtonClick() {
        this.selectLocation(
            this.props.locations.find(({ location_id }) => location_id === Number(this.state.selectedId))
        );
    }

    render() {
        var self = this;
        var page = this.props.page;
        var locations = this.props.locations;
        var selectedLocation = this.props.selectedLocation;

        if (page !== 'location') {
            document.getElementById('header').style.display = '';
            return null;
        }

        if (locations.length <= 1) {
            return <div className='gl-location' />;
        }

        // show loader until flags are fetched
        if (!this.state.flags) {
            return (
                <div
                    style={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <i className='fa fa-spinner fa-pulse' />
                </div>
            );
        }

        var showNewLocationSelect = this.state.flags['pos.register.dutchie-pos-redirect.rollout'] 
            || (this.state.flags['pos.register.redirect-unless-opted-out.rollout'] && !localStorage.getItem('v1OptOut'));

        // hide header if flag is enabled
        if (showNewLocationSelect) {
            document.getElementById('header').style.display = 'none';
        }
        // show new UI if flag is enabled
        if (showNewLocationSelect) {
            return (
                <div id='auth-reskin' className='auth-reskin'>
                    <div className='LayoutBase'>
                        <div className='HeroContainer'>
                            <img className='HeroImage' src='/assets/dutchie-hero.svg' />
                        </div>
                        <div className='AsideForm'>
                            <label>Select your location</label>
                            <div className='SelectWrapper'>
                                <select
                                    value={this.state.selectedId}
                                    placeholder='Select register'
                                    onChange={(event) => this.setState({ selectedId: event.target.value })}
                                >
                                    <option value='' disabled>
                                        Choose a Location
                                    </option>
                                    {locations.map((location) => (
                                        <option value={location.location_id}>{location.location_name}</option>
                                    ))}
                                </select>
                                <img className='Chevron' src='/assets/chevron-down.svg' />
                            </div>
                            <div className='ButtonContainer'>
                                <div>
                                    <button className='PrimaryButton' onClick={this.handleSelectLocationButtonClick}>
                                        Select Location
                                    </button>
                                </div>
                                <button
                                    className='LinkButton'
                                    onClick={() => {
                                        AuthActions.logout();
                                    }}
                                >
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className='gl-location'>
                <div className='gl-location__container'>
                    <div className='container'>
                        <div className='gl-location__contents'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='profile-main__container--header'>Select Location</div>
                                </div>
                            </div>
                            <div className='gl-location__list'>
                                {locations &&
                                    locations.map((loc, i) => {
                                        return (
                                            <div className='gl-location__row' key={loc.location_id}>
                                                <div className='gl-location__row--title'>{loc.location_name}</div>

                                                <div
                                                    className='gl-location__row--select'
                                                    onClick={self.selectLocation.bind(self, loc)}
                                                >
                                                    {selectedLocation.location_id === loc.location_id
                                                        ? 'SELECTED'
                                                        : 'SELECT'}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GLLocation;



// WEBPACK FOOTER //
// ./ui_src/app/components/guest-list/GLLocation.react.jsx